export default {"src":"/_next/static/media/cat-basic.b62527a6.svg","height":812,"width":900};